import React from "react";
import { ModelElementType } from "@/components/entities";
import { ModelRow } from "./ModelRow";
import { formatCompactRelativeTime } from "./selectors";

interface ModelRowsProps {
  models: ModelElementType[];
  /** The row just created plays the settle-in outline. */
  freshModelId?: string | null;
  showActiveCount?: boolean;
  movable?: boolean;
  /** Time each row by when it was pinned instead of last opened. */
  byPin?: boolean;
}

/** A list of model rows sharing one recency label and the fresh-row outline. */
export const ModelRows: React.FC<ModelRowsProps> = ({
  models,
  freshModelId,
  byPin = false,
  ...rowProps
}) => (
  <>
    {models.map((model) => {
      const at = byPin ? model.starred_at : model.last_opened_by_me;
      const time = at != null ? formatCompactRelativeTime(at) : undefined;
      return (
        <ModelRow
          key={model.model_id}
          model={model}
          isFresh={model.model_id === freshModelId}
          meta={time}
          metaTooltip={
            time &&
            `${byPin ? "Pinned" : "Opened"} ${time === "now" ? "just now" : `${time} ago`}`
          }
          {...rowProps}
        />
      );
    })}
  </>
);
